/* Uses the existing product-form and Shopify's automatic cart discounts. */
if (!customElements.get('emenne-complete-set')) {
  customElements.define('emenne-complete-set', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized || this.closest('quick-add-modal')) return;
      this.initialized = true;
      this.data = JSON.parse(this.querySelector('[data-em-set-data]').textContent);
      this.products = this.data.products.filter(Boolean);
      this.productIds = new Set(this.products.map(p => String(p.id)));
      this.cart = this.data.cart;
      this.rows = [...this.querySelectorAll('[data-product-id]')];
      this.info = this.closest('product-info');
      this.form = document.getElementById(this.dataset.formId);
      if (!this.form || !this.rows.length) return;
      this.productForm = this.form.closest('product-form');
      this.button = this.form.querySelector('[type="submit"]');
      this.buttonText = this.button.querySelector('span');
      this.defaultButtonText = window.variantStrings?.addToCart || this.buttonText.textContent;
      this.money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: this.dataset.currency, currencyDisplay: 'code'
      }).format(cents / 100);
      this.onChange = () => this.update();
      this.onFocus = () => this.refreshCart();
      this.info.addEventListener('change', this.onChange);
      this.info.addEventListener('input', this.onChange);
      window.addEventListener('focus', this.onFocus);
      this.unsubscribers = [];
      if (typeof subscribe === 'function') {
        this.unsubscribers.push(subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
          if (String(data.sectionId) === this.dataset.section) this.update();
        }));
        this.unsubscribers.push(subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refreshCart()));
        this.unsubscribers.push(subscribe(PUB_SUB_EVENTS.quantityUpdate, () => this.update()));
      }
      this.hidden = false;
      this.update();
      this.refreshCart();
    }
    disconnectedCallback() {
      this.info?.removeEventListener('change', this.onChange);
      this.info?.removeEventListener('input', this.onChange);
      window.removeEventListener('focus', this.onFocus);
      this.unsubscribers?.forEach(unsubscribe => unsubscribe());
      this.initialized = false;
    }
    async refreshCart() {
      const request = this.cartRequest = (this.cartRequest || 0) + 1;
      try {
        const response = await fetch(this.dataset.cartUrl, {headers:{Accept:'application/json'}, cache:'no-store'});
        if (!response.ok) return;
        const cart = await response.json();
        if (this.isConnected && request === this.cartRequest) { this.cart = cart; this.update(); }
      } catch (_) { /* Keep the last known cart; checkout remains authoritative. */ }
    }
    selection() {
      const formData = new FormData(this.form);
      const variant = this.data.main.variants.find(v => String(v.id) === String(formData.get('id')));
      const quantity = Math.max(1, parseInt(formData.get('quantity'), 10) || 1);
      const extras = this.rows.filter(row => row.querySelector('[data-add-item]').checked).map(row => {
        const product = this.products.find(p => String(p.id) === row.dataset.productId);
        const select = row.querySelector('[data-item-size]');
        const selected = product.variants.find(v => String(v.id) === select.value);
        return {product, variant:selected, select};
      });
      return {variant, quantity, extras};
    }
    update() {
      if (!this.form) return;
      this.rows.forEach(row => {
        const checked = row.querySelector('[data-add-item]').checked;
        const select = row.querySelector('[data-item-size]');
        row.querySelector('.em-complete-set__size').hidden = !checked;
        select.disabled = !checked;
        select.required = checked;
        const product = this.products.find(p => String(p.id) === row.dataset.productId);
        const variant = product.variants.find(v => String(v.id) === select.value);
        row.querySelector('[data-item-price]').textContent = this.money(variant?.price ?? product.price);
      });
      const {variant, quantity, extras} = this.selection();
      const cartCount = (this.cart?.items || []).filter(item =>
        this.productIds.has(String(item.product_id)) && !item.parent_relationship && !item.selling_plan_allocation
      ).reduce((sum, item) => sum + item.quantity, 0);
      const count = quantity + extras.length;
      const eligibleCount = count + cartCount;
      const rate = eligibleCount >= 3 ? 15 : eligibleCount >= 2 ? 10 : 0;
      this.querySelectorAll('[data-tier]').forEach(tier => tier.classList.toggle('is-active', Number(tier.dataset.tier) === rate));
      const summary = this.querySelector('[data-selection-summary]');
      summary.hidden = !rate && !extras.length;
      const ready = variant?.available && extras.every(extra => extra.variant?.available);
      if (!ready) {
        summary.textContent = 'Select an available size for each item.';
      } else {
        // Estimate only the new selection, including the tier earned by existing cart items.
        const total = [{price:variant.price, quantity}, ...extras.map(extra => ({price:extra.variant.price, quantity:1}))]
          .reduce((sum, line) => sum + Math.round(line.price * line.quantity * (100-rate)/100), 0);
        const label = quantity === 1 && extras.length === 2 ? 'The Set' : `${count} ${count === 1 ? 'item' : 'items'}`;
        const subtotal = variant.price * quantity + extras.reduce((sum, extra) => sum + extra.variant.price, 0);
        summary.replaceChildren();
        const addLine = (label, value, className = '') => {
          const row = document.createElement('div'); row.className = className;
          const name = document.createElement('span'); name.textContent = label;
          const amount = document.createElement('strong'); amount.textContent = value;
          row.append(name, amount); summary.append(row);
        };
        addLine('Subtotal', this.money(subtotal));
        if (rate) addLine(`You save ${rate}%`, '−' + this.money(subtotal-total), 'em-selection-saving');
        addLine('Total', this.money(total), 'em-selection-total');
        if (cartCount) {
          const note = document.createElement('small');
          note.textContent = 'Savings include qualifying items already in your bag. Total shown is for this selection.';
          summary.append(note);
        }
      }
      if (!this.button.disabled && this.button.getAttribute('aria-disabled') !== 'true') {
        this.buttonText.textContent = extras.length ? (quantity === 1 && extras.length === 2 ? 'Add The Set to bag' : `Add ${count} items to bag`) : this.defaultButtonText;
      }
      // Express checkout only adds the main product, so hide it while complements are selected.
      const express = this.form.querySelector('.shopify-payment-button');
      if (express) express.hidden = extras.length > 0;
    }
    prepareItems() {
      if (!this.form || this.hidden) return null;
      const {variant, quantity, extras} = this.selection();
      if (!extras.length) return null; // Preserve the original single-product flow.
      if (!variant?.available) {
        this.productForm.handleErrorMessage('Select an available size for the main item.');
        return false;
      }
      for (const extra of extras) {
        if (!extra.variant?.available) {
          this.productForm.handleErrorMessage('Select an available size for each item.');
          extra.select.focus();
          extra.select.reportValidity();
          return false;
        }
      }
      return [{id:variant.id, quantity}, ...extras.map(extra => ({id:extra.variant.id, quantity:1}))];
    }
    appendItems(formData, items) {
      // Preserve any existing main-product properties and selling plan.
      [...formData.entries()].forEach(([key, value]) => {
        if (key === 'id' || key === 'quantity' || key === 'selling_plan' || key.startsWith('properties[')) {
          formData.delete(key);
          if (key === 'selling_plan' || key.startsWith('properties[')) {
            const nested = key === 'selling_plan' ? 'items[0][selling_plan]' : `items[0][properties]${key.slice(10)}`;
            formData.append(nested, value);
          }
        }
      });
      items.forEach((item, index) => {
        formData.append(`items[${index}][id]`, item.id);
        formData.append(`items[${index}][quantity]`, item.quantity);
      });
    }
  });
}
